import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { TextInputWithTokens, Autocomplete, Select } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/FormControl"
      }}>{`FormControl`}</a>{` instead.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<InputField>
  <InputField.Label>Name</InputField.Label>
  <TextInput />
</InputField>
`}</code></pre>
    <h3>{`Required`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<InputField required>
  <InputField.Label>Name</InputField.Label>
  <TextInput />
</InputField>
`}</code></pre>
    <h3>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<InputField disabled>
  <InputField.Label>Name</InputField.Label>
  <TextInput />
</InputField>
`}</code></pre>
    <h3>{`Using different input components`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline deprecated",
        "live": true,
        "noinline": true,
        "deprecated": true
      }}>{`const TextInputWithTokensExample = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2},
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        '> * + *': {
          marginTop: 4,
        },
      }}
    >
      <InputField>
        <InputField.Label>TextInputWithTokens</InputField.Label>
        <TextInputWithTokens onTokenRemove={onTokenRemove} tokens={tokens} />
      </InputField>
      <InputField>
        <InputField.Label>Autocomplete</InputField.Label>
        <Autocomplete>
          <Autocomplete.Input block />
          <Autocomplete.Overlay>
            <Autocomplete.Menu
              items={[
                {text: 'css', id: 0},
                {text: 'css-in-js', id: 1},
                {text: 'styled-system', id: 2},
                {text: 'javascript', id: 3},
                {text: 'typescript', id: 4},
                {text: 'react', id: 5},
                {text: 'design-systems', id: 6},
              ]}
              selectedItemIds={[]}
            />
          </Autocomplete.Overlay>
        </Autocomplete>
      </InputField>
      <InputField>
        <InputField.Label>Select</InputField.Label>
        <Select>
          <Select.Option value="figma">Figma</Select.Option>
          <Select.Option value="css">Primer CSS</Select.Option>
          <Select.Option value="prc">Primer React components</Select.Option>
          <Select.Option value="pvc">Primer ViewComponents</Select.Option>
        </Select>
      </InputField>
    </Box>
  )
}

render(TextInputWithTokensExample)
`}</code></pre>
    <h3>{`With a visually hidden label`}</h3>
    <Note mdxType="Note">
      <p>{`Every input must have a corresponding label to be accessible to assistive technology. That's why you'd use `}<inlineCode parentName="p">{`InputField`}</inlineCode>{` instead of using `}<a parentName="p" {...{
          "href": "/TextInput"
        }}><inlineCode parentName="a">{`TextInput`}</inlineCode></a>{` directly.`}</p>
      <p><inlineCode parentName="p">{`InputField`}</inlineCode>{` also provides an interface for showing a hint text caption and a validation message, and associating those with the input for assistive technology.`}</p>
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<InputField>
  <InputField.Label visuallyHidden>Name</InputField.Label>
  <TextInput />
</InputField>
`}</code></pre>
    <h3>{`With a caption`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<InputField>
  <InputField.Label>Name</InputField.Label>
  <TextInput />
  <InputField.Caption>Hint: your first name</InputField.Caption>
</InputField>
`}</code></pre>
    <h3>{`With validation`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline deprecated",
        "live": true,
        "noinline": true,
        "deprecated": true
      }}>{`const ValidationExample = () => {
  const [value, setValue] = React.useState('mona lisa')
  const [validationResult, setValidationResult] = React.useState()
  const doesValueContainSpaces = inputValue => /\\s/g.test(inputValue)
  const handleInputChange = e => {
    setValue(e.currentTarget.value)
  }

  React.useEffect(() => {
    if (doesValueContainSpaces(value)) {
      setValidationResult('noSpaces')
    } else if (value) {
      setValidationResult('validName')
    }
  }, [value])

  return (
    <InputField
      validationMap={{
        noSpaces: 'error',
        validName: 'success',
      }}
      validationResult={validationResult}
    >
      <InputField.Label>GitHub handle</InputField.Label>
      <TextInput block value={value} onChange={handleInputChange} />
      <InputField.Validation validationKey="noSpaces">GitHub handles cannot contain spaces</InputField.Validation>
      <InputField.Validation validationKey="validName">Valid name</InputField.Validation>
      <InputField.Caption>With or without "@". For example "monalisa" or "@monalisa"</InputField.Caption>
    </InputField>
  )
}

render(ValidationExample)
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`InputField`}</h3>
    <p>{`The container that handles the layout and passes the relevant IDs and ARIA attributes it's children.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="InputField.Label | InputField.Caption | InputField.Validation | Autocomplete | TextInput | TextInputWithTokens | Select" required mdxType="PropsTableRow" />
  <PropsTableRow name="disabled" type="boolean" defaultValue="false" description="Whether the field is ready for user input" mdxType="PropsTableRow" />
  <PropsTableRow name="id" type="string" defaultValue="a generated string" description="The unique identifier for this field. Used to associate the label, validation text, and caption text" mdxType="PropsTableRow" />
  <PropsTableRow name="required" type="boolean" defaultValue="false" description="Whether the field is ready for user input" mdxType="PropsTableRow" />
  <PropsTableRow name="validationMap" type="Record<string, 'error'|'success'>" description="A map of validation statuses and their associated validation keys. When one of the validation keys is passed to the `validationResult` prop, the associated validation message will be rendered in the correct style" mdxType="PropsTableRow" />
  <PropsTableRow name="validationResult" type="string" description="The key of the validation message to show " mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`InputField.Label`}</h3>
    <p>{`A `}<inlineCode parentName="p">{`InputField.Label`}</inlineCode>{` must be passed for the field to be accessible to assistive technology, but it may be visually hidden.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="boolean" type="InputField.Label | InputField.Caption | InputField.Validation | Autocomplete | TextInput | TextInputWithTokens" defaultValue="false" description="Whether the label should be visually hidden" mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`InputField.Caption`}</h3>
    <p><inlineCode parentName="p">{`InputField.Caption`}</inlineCode>{` may be used to render hint text for fields that require additional context.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" description="The content (usually just text) that is rendered to give contextual info about the field" mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`InputField.Validation`}</h3>
    <p><inlineCode parentName="p">{`InputField.Validation`}</inlineCode>{` may be used to render contextual validation information if the field was flagged during validation.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" description="The content (usually just text) that is rendered to give contextual info about the validation result for the field" mdxType="PropsTableRow" />
  <PropsTableRow name="validationKey" type="string" description="The key of the property from `InputField` that corresponds to this validation message. When `InputField`'s `validationResult` prop matches `InputField.Validation`'s `validationKey` prop, this message is shown." mdxType="PropsTableRow" />
    </PropsTable>
    <h2>{`Component status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ChoiceInputField"
        }}>{`ChoiceInputField`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/TextInput"
        }}>{`TextInput`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      